<div
  class="holder"
  [ngClass]="{
    active: active,
    'small-tag': size === 'small',
    'medium-tag': size === 'medium',
  }"
  (mouseleave)="out.next()"
  (click)="clicked($event)">
  <ng-container *ngIf="user; else noUser">
    <span class="first_name" *ngIf="user.first_name">
      {{ user.first_name }}
    </span>
    <span class="name">{{ user.name }}</span>

    <span
      class="organization"
      *ngIf="user.organization && showOrg"
      (mouseenter)="''.next()"
      (mouseleave)="out.next()">
      ({{ user.organization }})
    </span>

    {{ postfix }}

    <div class="widget" *ngIf="hint">
      <a href="/profile/{{ user._id }}" target="_blank" (click)="closeModals()">
        See Profile
      </a>
    </div>
  </ng-container>
  <ng-template #noUser>N.N.</ng-template>
</div>
